import React, { useState } from "react";
import {
    SwitchButtonComponet,
    TextInputComponent,
    DatePickerComponent,
    IconButtonComponent
} from "../../../../component/atom";
import { Alert, Box, Card, CardContent, Divider, Grid, Stack, Typography, CircularProgress } from "@mui/material";
import HeadingComponent from "../../../../component/atom/Headings/Heading";
import { connect } from "react-redux";
import { Actions } from "../../../../core/modules/Actions";
import TextButtonComponet from "../../../../component/atom/Buttons/TextButton";
import _ from "lodash";
import { getText, planFields, THEME_COLORS } from "../../../../core/Constant";
import TextAreaComponent from "../../../../component/atom/Inputs/TextArea";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle, faXmark } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import ThumbnailUploadComponent from "../../../../component/atom/ThumbnailUploadComponent/ThumbnailUploadComponent";
import { useNavigate } from "react-router-dom";


const AdminCoursAddScreen = ({ createCourse }) => {
    const navigate = useNavigate();

    const createEmptyPlan = (id) => ({ id , ...planFields });

    const [name, setName] = useState("");
    const [nameError, setNameError] = useState(false);
    const [nameValid, setNameVaid] = useState(false);

    const [duration, setDuration] = useState("");
    const [durationError, setDurationError] = useState(false);
    const [durationValid, setDurationVaid] = useState(false);

    const [priority, setPriority] = useState("");
    const [priorityError, setPriorityError] = useState(false);
    const [priorityValid, setPriorityValid] = useState(false);

    const [planErrors, setPlanErrors] = useState([
      {
        batch: "",
        duration : "",
        expiry : "",
        planName : "",
        price : "",
      }
    ]);

    const [lecturer, setLecturer] = useState("");
    const [lecturerError, setLecturerError] = useState(false);
    const [lecturerValid, setLecturerVaid] = useState(false);

    const [description, setDescription] = useState("");
    const [descriptionError, setDescriptionError] = useState(false);
    const [descriptionValid, setDescriptionVaid] = useState(false);

    const [freeCourse, setFreeCourse] = useState(0);
    const [freeCourseInfo, setFreeCourseInfo] = useState("");

    const [img, setImg] = useState(null);
    const [imgPath, setImgPath] = useState("");
    const [isUploadedImg, setIsUploadedImg] = useState(false);
    const [walkthroughVideo, setWalkthroughVideo] = useState(null);
    const [isWalkthroughMandatory, setIsWalkthroughMandatory] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [newImageError, setNewImageError] = useState(false);
    const [newImageErrorMsg, setNewImageErrorMsg] = useState("");


    const [inVisible, setInVisible]=useState(0);
    const [isMultipleBatch, setMultipleBatch] = useState(0);
    const [plans, setPlans] = useState([
      createEmptyPlan(1)
    ]);
  
    const onNameChange = (e) => {
        const text = getText(e);
        setName(text);
        setNameError(false);
        const isValid = text?.length > 0;
        setNameVaid(isValid);
    };

    const onDurationChange = (e) => {
        const text = getText(e);
        setDuration(text);
        setDurationError(false);
        const isValid = text > 0;
        setDurationVaid(isValid);
    };

    const onPriorityChange = (e) => {
        const text = getText(e);
        setPriority(text);
        setPriorityError(false);
        const isValid = text > 0;
        setPriorityValid(isValid);
    };

    const onDescriptionChange = (e) => {
        const text = getText(e);
        setDescription(text);
        setDescriptionError(false);
        const isValid = text?.length > 0;
        setDescriptionVaid(isValid);
    };

    const onLecturerChange = (e) => {
        const text = getText(e);
        setLecturer(text);
        setLecturerError(false);
        const isValid = text?.length > 0;
        setLecturerVaid(isValid);
    };

    const onChangekMarkAsFree = (value) => {
        let currentValue = value.target.checked;
        let freeCourseState = currentValue ? 1 : 0;
        setFreeCourse(freeCourseState);
    };

  const onChangeMultipleBatch = (value) => {
    let currentValue = value.target.checked;
    let multipleBatchState = currentValue ? 1 : 0;
    setMultipleBatch(multipleBatchState);

    setPlans((prevPlans) => {
    if (currentValue) {
      if (prevPlans.length === 1) {
        return [
          ...prevPlans,
          createEmptyPlan(2),
        ];
      }

      return prevPlans.slice(0, 2);
    }

    return prevPlans.slice(0, 1);
  });
  };

  const validatePlan = (plan) => {
    const errors = {
      planName: "",
      duration: "",
      price: "",
      expiry: "",
      batch: "",
    };

    let isValid = true;

    const duration = Number(plan?.duration || 0);
    const price = Number(plan?.price || 0);
    if (isMultipleBatch === 1 && !plan?.planName?.trim()) {
      errors.planName = "Add valid plan type.";
      isValid = false;
    }

    if (duration <= 0) {
      errors.duration = "Add valid duration.";
      isValid = false;
    }

    if (price <= 0) {
      errors.price = "Add valid price.";
      isValid = false;
    }

    if (!plan?.planExpiryDate) {
      errors.expiry = "Add valid course expiry date.";
      isValid = false;
    }

    if (!plan?.batchMonth || !plan?.batchYear) {
      errors.batch = "Add valid batch month and year.";
      isValid = false;
    }

    return {
      isValid,
      errors,
      duration,
    };
  };

  const validatePlans = () => {
    if (freeCourse === 1) return true;

    let isValid = true;

    const errors = [];

    plans.forEach((plan, index) => {
      const result = validatePlan(plan);

      errors[index] = result.errors;

      if (!result.isValid) {
        isValid = false;
      }
    });

    setPlanErrors(errors);

    return isValid;
  };

   const onAddCourse = () => {
    if (isSubmitting) return;

    const isValidPlans = validatePlans();
    if (
      isValidPlans &&
      nameValid &&
      descriptionValid &&
      lecturerValid &&
      isUploadedImg &&
      priorityValid &&
      (freeCourse !== 1 || durationValid)
    ) {
      const data = new FormData();
      data.append("name", name);
      data.append("is_invisible", inVisible);
      if (freeCourse === 1) {
        data.append("duration", Number(duration));
      } else {
        data.append("is_multi_batch", isMultipleBatch);
      }
      data.append("lecturer", lecturer);
      data.append("description", description);
      data.append("is_free", freeCourse);
      data.append("course_info", freeCourseInfo);
      data.append("image", img);
      data.append("priority", priority);
      if (walkthroughVideo) {
        data.append("walkthrough_video", walkthroughVideo);
      }
      data.append("is_walkthrough_video_mandatory", isWalkthroughMandatory ? 1 : 0);

      if (freeCourse !== 1) {
        const configuredPlans = plans.filter((plan) => {
          return (
            Number(plan.duration) > 0 &&
            Number(plan.price) > 0 &&
            plan.planExpiryDate &&
            plan.batchMonth &&
            plan.batchYear
          );
        });
        const singlePlan = plans?.[0];
        if (isMultipleBatch) {
          configuredPlans.forEach((plan, index) => {
            data.append(`plans[${index}][plan_name]`, plan.planName);
            data.append(`plans[${index}][duration_weeks]`, plan.duration);
            data.append(`plans[${index}][price]`, plan.price);
            data.append(`plans[${index}][expires_at]`, plan.planExpiryDate);
            data.append(`plans[${index}][batch_month]`, plan.batchMonth);
            data.append(`plans[${index}][batch_year]`, plan.batchYear);
          });
        } else {
          data.append(`plans[0][plan_name]`, singlePlan?.planName);
          data.append(`plans[0][duration_weeks]`, singlePlan.duration);
          data.append(`plans[0][price]`, singlePlan.price);
          data.append(`plans[0][expires_at]`, singlePlan.planExpiryDate);
          data.append(`plans[0][batch_month]`, singlePlan.batchMonth);
          data.append(`plans[0][batch_year]`, singlePlan.batchYear);
        }
      } else {
        data.append("course_plan_code[]", "");
        data.append("duration_weeks[]", 0);
        data.append("price[]", 0);
        data.append("expires_at[]", "");
        data.append(`batch_month[]`, 0);
        data.append(`batch_year[]`, 0);
      }

      setIsSubmitting(true);
      createCourse(data).finally(() => setIsSubmitting(false));
    } else {
      if (!nameValid) {
        setNameError(true);
      }

      if (freeCourse == 1 && !durationValid) {
        setDurationError(true);
      }
      if (!descriptionValid) {
        setDescriptionError(true);
      }
      if (!priorityValid) {
        setPriorityError(true);
      }
      if (!lecturerValid) {
        setLecturerError(true);
      }
      if (!isUploadedImg) {
        setNewImageError(true);
        setNewImageErrorMsg("Please add course thumbnail");
      }
    }
  };

  const formatFileSize = (bytes) => `${(bytes / (1024 * 1024)).toFixed(2)} MB`;

  const handlePlanChange = (index, field, value) => {
     setPlans((prev) =>
      prev.map((plan, i) => {
        if (i !== index) return plan;
        if (field === "batchYear") {
          const newYear = Number(value);
          const currentYear = moment().year();
          const currentMonth = moment().month() + 1;
  
          const existingMonth = Number(plan.batchMonth);
          let updatedBatchMonth = plan.batchMonth;
  
          if (existingMonth) {
            if (
              newYear === currentYear &&
              existingMonth < currentMonth
            ) {
              updatedBatchMonth = "";
            }
          }
  
          return {
            ...plan,
            batchYear: value,
            batchMonth: updatedBatchMonth,
          };
        }
  
        return {
          ...plan,
          [field]: value,
        };
      })
    );
    setPlanErrors((prev) => {
      const updated = [...prev];
      updated[index] = {
        ...updated[index],
        [field]: "",
      };
      return updated;
    });
    if(field === "batchMonth" || field === "batchYear" ){
      setPlanErrors((prev) => {
      const updated = [...prev];
      updated[index] = {
        ...updated[index],
        batch: "",
      };
      return updated;
      });
    }

    if(field === "planExpiryDate"){
     setPlanErrors((prev) => {
      const updated = [...prev];
      updated[index] = {
        ...updated[index],
        expiry: "",
      };
      return updated;
      });
    }
  };

  const handleDeletePlan = (index) => {
    setPlans((prev) => prev.filter((_, i) => i !== index));

    setPlanErrors((prev) =>
      prev.filter((_, i) => i !== index)
    );
  };

  const handleAddPlan = () => {
    setPlans((prev) => [
      ...prev,
      createEmptyPlan(Date.now())
    ]);
  };

  const isProvideMarginBottom = (index) => {
    const errors = planErrors[index];
    if (!errors) return true;
    return !(
      errors.planName ||
      errors.duration ||
      errors.price ||
      errors.expiry ||
      errors.batch
    );
  };

    
    return (
        <>
            <div>
                {isSubmitting && (
                  <Box
                    sx={{
                      position: "fixed",
                      inset: 0,
                      zIndex: 1300,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      backgroundColor: "rgba(255, 255, 255, 0.65)",
                    }}
                  >
                    <CircularProgress />
                  </Box>
                )}
                <Box className="main-screen-container">
                    <Grid container direction="row" justifyContent="space-between">
                        <Grid item>
                            <HeadingComponent
                                text={`Add Course`}
                                fontweigth={600}
                                size={40}
                                fontfamily={"Montserrat"}
                                backNavigation={true}
                            />
                          </Grid>
                    </Grid>
                    
                    <Grid p={4} container>
                      <Grid md={12} xs={12}>
                        <Card
                          elevation={0}
                          sx={{
                            borderRadius: 3,
                            border: `1px solid ${THEME_COLORS.grayLight}`,
                          }}
                        >
                          <CardContent sx={{ p: 4 }}>
                             <Stack
                               direction="row"
                               spacing={1}
                               alignItems="center"
                               mb={4}
                               ml={1}
                             >                              
                             <FontAwesomeIcon
                                size={"lg"}
                                icon={faInfoCircle}
                                style={{
                                  color: THEME_COLORS.primary,
                                }}
                              />
                              <Typography variant="h6" fontWeight={600}>
                                Basic Details
                              </Typography>
                            </Stack>
                    
                            <Grid container spacing={1}>
                              <Grid item xs={12} md={6}>
                                <TextInputComponent
                                  label={"Course Name"}
                                  placeholder="Enter your course name"
                                  value={name}
                                  isError={nameError}
                                  error="Please enter the course name"
                                  onchange={onNameChange}
                                />
                              </Grid>
                    
                              <Grid item xs={12} md={6}>
                                <TextInputComponent
                                  label={"Lecturer Name"}
                                  placeholder="Enter lecturer name"
                                  value={lecturer}
                                  isError={lecturerError}
                                  error="Please enter the lecturer name"
                                  onchange={onLecturerChange}
                                />
                              </Grid>
                    
                              <Grid item xs={12} md={6}>
                                <Box style={{ padding: 10 }}>
                                  <Box className="add-course-free-box">
                                    <Box>
                                      <Typography
                                        color={THEME_COLORS.gray3}
                                        fontWeight={600}
                                        fontSize={18}
                                      >
                                        Free Course
                                      </Typography>
                    
                                      <Typography variant="body2" color="text.secondary">
                                        Make this course accessible to everyone
                                      </Typography>
                                    </Box>
                                    <SwitchButtonComponet
                                      checked={freeCourse == 1 ? true : false}
                                      onChange={(e) => onChangekMarkAsFree(e)}
                                      inputProps={{ "aria-label": "controlled" }}
                                    />
                                  </Box>
                                </Box>
                              </Grid>
                    
                              {freeCourse === 0 && (
                                <Grid item xs={12} md={6}>
                                  <Box style={{ padding: 10 }}>
                                    <Box className="add-course-free-box">
                                      <Box>
                                        <Typography
                                          color={THEME_COLORS.gray3}
                                          fontWeight={600}
                                          fontSize={18}
                                        >
                                          Multi Batch
                                        </Typography>
                    
                                         <Typography
                                          variant="body2"
                                          color="text.secondary"
                                        >                                          
                                        Make this course with multiple batch
                                        </Typography>
                                      </Box>
                                      <SwitchButtonComponet
                                        checked={isMultipleBatch == 1}
                                        onChange={(e) => onChangeMultipleBatch(e)}
                                        inputProps={{ "aria-label": "controlled" }}
                                      />
                                    </Box>
                                  </Box>
                                </Grid>
                              )}
                    
                              {freeCourse == 1 && (
                                <Grid item xs={12} md={6}>
                                  <TextInputComponent
                                    label={"Duration (Weeks)"}
                                    placeholder="Enter course duration"
                                    type={"number"}
                                    value={duration}
                                    isError={durationError}
                                    error="Please enter the valid duration"
                                    onchange={onDurationChange}
                                  />
                                </Grid>
                              )}
                    
                              <Grid item xs={12} md={6}>
                                <TextInputComponent
                                  label={"Priority"}
                                  placeholder="Enter course priority"
                                  type={"number"}
                                  value={priority}
                                  isError={priorityError}
                                  error="Please enter the valid priority"
                                  onchange={onPriorityChange}
                                />
                              </Grid>

                              {freeCourse == 1 && (
                                <Grid item xs={12} md={6}>
                                  <TextInputComponent
                                    label={"Free Course Info"}
                                    placeholder="Enter free course info"
                                    name="title"
                                    value={freeCourseInfo}
                                    onchange={(e) => setFreeCourseInfo(getText(e))}
                                  />
                                </Grid>
                              )}
                            </Grid>
                          </CardContent>
                        </Card>
                      </Grid>
                      {freeCourse === 0 && (
                        <Grid md={12} xs={12} mt={3}>
                          <Card
                            elevation={0}
                            sx={{
                              borderRadius: 3,
                              border: `1px solid ${THEME_COLORS.grayLight}`,
                              bgcolor: THEME_COLORS.primaryLight,
                              opacity: freeCourse === 1 ? 0.6 : 1,
                              pointerEvents: freeCourse === 1 ? "none" : "auto",
                              transition: "all 0.2s ease",
                            }}
                          >
                            <CardContent sx={{ p: 4 }}>
                              <Typography
                                 color={THEME_COLORS.gray3}
                                 fontWeight={700}
                                 fontSize={28}
                               >  
                                Plan Configuration
                              </Typography>
                    
                              <Typography color="text.secondary" mb={4}>
                                Define subscription tiers for this course
                              </Typography>
                    
                              <Alert
                                severity="info"
                                icon={
                                  <FontAwesomeIcon
                                    color={THEME_COLORS.grayDark}
                                    icon={faInfoCircle}
                                  />
                                }
                                sx={{
                                  mb: 4,
                                  borderRadius: 2,
                                  bgcolor: THEME_COLORS.white,
                                  border: "1px solid #E6E8F0",
                    
                                  "& .MuiAlert-message": {
                                    color: THEME_COLORS.grayDark,
                                  },
                                }}
                              >
                                If both plans are configured, both will be visible in the
                                student portal. If only one plan is configured, only that
                                plan will be displayed.
                              </Alert>
                    
                              <Grid
                                container
                                spacing={2}
                                mb={2}
                                sx={{ display: { xs: "none", md: "flex" } }}
                              >
                                  <Grid item xs={2}>
                                     <Typography
                                       color={THEME_COLORS.gray3}
                                       fontWeight={700}
                                     >                           
                                      Plan Type
                                    </Typography>
                                  </Grid>
                                
                    
                                <Grid item xs={2}>
                                  <Typography color={THEME_COLORS.gray3} fontWeight={700}>
                                    Duration (Weeks)
                                  </Typography>
                                </Grid>
                    
                                <Grid item xs={2}>
                                  <Typography color={THEME_COLORS.gray3} fontWeight={700}>
                                    Course Expiry Date
                                  </Typography>
                                </Grid>
                                <Grid item xs={3}>
                                  <Typography color={THEME_COLORS.gray3} fontWeight={700}>
                                    Batch
                                  </Typography>
                                </Grid>
                                <Grid item xs={2}>
                                  <Typography color={THEME_COLORS.gray3} fontWeight={700}>
                                    Price (USD)
                                  </Typography>
                                </Grid>
                                <Grid item xs={1}></Grid>
                              </Grid>
                    
                              <Divider sx={{ mb: 3 }} />
                              <Box sx={{ display: { xs: "block", md: "none" } }}>
                                {plans?.map((plan, index) => {
                                  if (isMultipleBatch === 0 && index === 1) {
                                    return null;
                                  }
                                  const currentYear = moment().year();
                                  const effectiveBatchYear = plan?.batchYear
                                    ? Number(plan.batchYear)
                                    : currentYear;
                                  const isCurrentYear = effectiveBatchYear === currentYear;
                                  const monthMinDate = isCurrentYear
                                    ? moment().startOf("month").toDate()
                                    : moment({
                                        year: effectiveBatchYear,
                                        month: 0,
                                        day: 1,
                                      })
                                        .startOf("month")
                                        .toDate();
                                                      
                                     const monthMaxDate = moment({
                                       year: effectiveBatchYear,
                                       month: 11,
                                       day: 1,
                                     })
                                       .endOf("month")
                                       .toDate();
                                  return (
                                    <>
                                     
                                    <Card
                                      key={index}
                                      elevation={0}
                                      sx={{
                                        mb: 3,
                                        p: 2,
                                        border: "1px solid #E5E7EB",
                                        borderRadius: 2,
                                        bgcolor: "white",
                                      }}
                                    >
                                      
                                      <Grid container spacing={2} alignItems="center">
                                        <Grid item xs={12} md={4}>
                                            
                                              <Typography
                                                sx={{
                                                  fontWeight: 700,
                                                  mb: 1,
                                                  color: THEME_COLORS.gray3,
                                                }}
                                              >
                                                Plan Type
                                              </Typography>
                    
                                              <TextInputComponent
                                                placeholder=""
                                                backgroundColor={THEME_COLORS.white}
                                                borderStyle="solid"
                                                value={plan?.planName}
                                                containerStyle={{
                                                  padding: 0,
                                                }}
                                                onchange={(e) =>
                                                 handlePlanChange(
                                                   index,
                                                   "planName",
                                                   e.target.value,
                                                 )
                                               }
                                              />
                                              {planErrors?.[index]?.planName && (
                                               <Typography
                                                fontWeight={500}
                                                ml={1}
                                                className="input-error-text"
                                              >
                                                {planErrors?.[index]?.planName}
                                              </Typography>
                                             )}
                                            
                                          
                                        </Grid>
                    
                                        <Grid item xs={12} sm={6} md={4}>
                                          <Typography
                                            sx={{
                                              fontWeight: 700,
                                              mb: 1,
                                              color: THEME_COLORS.gray3,
                                            }}
                                          >
                                            Duration (Weeks)
                                          </Typography>
                    
                                          <TextInputComponent
                                            type="number"
                                            placeholder=""
                                            backgroundColor={THEME_COLORS.white}
                                            borderStyle="solid"
                                            value={plan?.duration}
                                            onchange={(e) =>
                                              handlePlanChange(
                                                index,
                                                "duration",
                                                e.target.value,
                                              )
                                            }
                                            containerStyle={{
                                              padding: 0,
                                            }}
                                          />
                                          {planErrors?.[index]?.duration && (
                                            <Typography
                                              fontWeight={500}
                                              ml={1}
                                              className="input-error-text"
                                            >
                                              {planErrors?.[index]?.duration}
                                            </Typography>
                                          )}
                                        </Grid>
                    
                                        <Grid item xs={12} sm={6} md={4}>
                                          <Typography
                                            sx={{
                                              fontWeight: 700,
                                              mb: 1,
                                              color: THEME_COLORS.gray3,
                                            }}
                                          >
                                            Course Expiry Date
                                          </Typography>
                                          <DatePickerComponent
                                            containeStyle={{
                                              padding: 0,
                                            }}
                                            customInput={
                                              <input
                                                style={{
                                                  backgroundColor: THEME_COLORS.white,
                                                  border: `1px solid ${THEME_COLORS.inputBorderColor}`,
                                                }}
                                              />
                                            }
                                            dateFormat="dd/MM/yyyy"
                                            minDate={moment().startOf("day").toDate()}
                                            selected={
                                              plan?.planExpiryDate &&
                                              moment(
                                                plan.planExpiryDate,
                                                "YYYY-MM-DD",
                                                true,
                                              ).isValid()
                                                ? moment(
                                                    plan.planExpiryDate,
                                                    "YYYY-MM-DD",
                                                  ).toDate()
                                                : null
                                            }
                                            onChange={(date) => {
                                              handlePlanChange(
                                                index,
                                                "planExpiryDate",
                                                date
                                                  ? moment(date).format("YYYY-MM-DD")
                                                  : "",
                                                );
                                            }}
                                          />
                                          {planErrors?.[index]?.expiry && (
                                            <Typography
                                              fontWeight={500}
                                              ml={1}
                                              className="input-error-text"
                                            >
                                              {planErrors?.[index]?.expiry}
                                            </Typography>
                                          )}
                                        </Grid>
                    
                                        <Grid item xs={12} sm={6} md={4}>
                                          <Typography
                                            sx={{
                                              fontWeight: 700,
                                              mb: 1,
                                              color: THEME_COLORS.gray3,
                                            }}
                                          >
                                            Batch Month
                                          </Typography>
                    
                                          <DatePickerComponent
                                           containeStyle={{
                                             padding: 0,
                                           }}
                                           customInput={
                                             <input
                                               style={{
                                                 backgroundColor: THEME_COLORS.white,
                                                 border: `1px solid ${THEME_COLORS.inputBorderColor}`,
                                               }}
                                             />
                                           }
                                           dateFormat="MMMM"
                                           showMonthYearPicker
                                           minDate={monthMinDate}                                                
                                           maxDate={monthMaxDate}
                                           placeholderText="Month"
                                           selected={
                                             plan?.batchMonth
                                             ? moment({
                                                 year: Number(plan?.batchYear) || moment().year(),
                                                 month: Number(plan.batchMonth) - 1,
                                                 day: 1,
                                               }).toDate()
                                             : null
                                          }
                                          onChange={(date) => {
                                            handlePlanChange(
                                              index,
                                              "batchMonth",
                                              moment(date).month() + 1,
                                            );
                                          }}
                                        />
                                          {planErrors?.[index]?.batch && (
                                            <Typography
                                              fontWeight={500}
                                              ml={1}
                                              className="input-error-text"
                                            >
                                              {planErrors?.[index]?.batch}
                                            </Typography>
                                          )}
                                        </Grid>
                    
                                        <Grid item xs={12} sm={6} md={4}>
                                          <Typography
                                            sx={{
                                              fontWeight: 700,
                                              mb: 1,
                                              color: THEME_COLORS.gray3,
                                            }}
                                          >
                                            Batch Year
                                          </Typography>
                    
                                          <DatePickerComponent
                                           containeStyle={{
                                             padding: 0,
                                           }}
                                           customInput={
                                             <input
                                               style={{
                                                 backgroundColor: THEME_COLORS.white,
                                                 border: `1px solid ${THEME_COLORS.inputBorderColor}`,
                                               }}
                                             />
                                           }
                                          showYearPicker
                                          minDate={moment().startOf("year").toDate()}
                                          placeholderText="Year"
                                          selected={
                                            plan?.batchYear
                                              ? moment()
                                                  .year(Number(plan.batchYear))
                                                  .startOf("year")
                                                  .toDate()
                                              : null
                                          }
                                           dateFormat="yyyy"
                                           onChange={(date) => {
                                             handlePlanChange(
                                               index,
                                               "batchYear",
                                               moment(date).year(),
                                             );
                                           }}
                                         />
                                          {planErrors?.[index]?.batch && (
                                            <Typography
                                              fontWeight={500}
                                              ml={1}
                                              className="input-error-text"
                                            >
                                              {planErrors?.[index]?.batch}
                                            </Typography>
                                          )}
                                        </Grid>
                    
                                        <Grid item xs={12} sm={6} md={4}>
                                          <Typography
                                            sx={{
                                              fontWeight: 700,
                                              mb: 1,
                                              color: THEME_COLORS.gray3,
                                            }}
                                          >
                                            Price (USD)
                                          </Typography>
                    
                                          <TextInputComponent
                                            type="number"
                                            placeholder=""
                                            backgroundColor={THEME_COLORS.white}
                                            borderStyle="solid"
                                            value={plan?.price}
                                            onchange={(e) =>
                                              handlePlanChange(
                                                index,
                                                "price",
                                                e.target.value,
                                             )
                                            }
                                            containerStyle={{
                                              padding: 0,
                                            }}
                                          />
                                          {planErrors?.[index]?.price && (
                                            <Typography
                                              fontWeight={500}
                                              ml={1}
                                              className="input-error-text"
                                            >
                                              {planErrors?.[index]?.price}
                                            </Typography>
                                          )}
                                        </Grid>
                                      </Grid>
                                      {index > 1 && (
                                        <Box sx={{
                                          width:"100%",
                                          display:"flex",
                                          justifyContent:"flex-end",
                                          mb:1
                                        }}>
                                         <Box
                                           sx={{
                                            display:"flex",
                                            justifyContent:"center",
                                            alignItems:"center",
                                            mt:2,
                                            width:"100%"
                                           }}
                                           onClick={() => handleDeletePlan(index)}
                                         >
                                           <TextButtonComponet
                                             text="Delete Plan"
                                             classStyle="btn btn-danger"
                                             onButtonClick={()=> handleDeletePlan(index)}
                                           />
                                           </Box>
                                         </Box>
                                       )}
                                    </Card>
                                    { index > 0 && (index + 1 === plans?.length) && (
                                        <Box
                                          sx={{
                                            mb:5
                                          }}
                                        >
                                           <TextButtonComponet
                                             text={"Add Plan"}
                                             onButtonClick={handleAddPlan}
                                           />
                                          </Box>
                                        ) 
                                      }
                                    </>
                                  );
                                })}
                              </Box>
                              <Box sx={{ display: { xs: "none", md: "block" } }}>
                                {plans?.map((plan, index) => {
                                  if (isMultipleBatch === 0 && index === 1) {
                                    return null;
                                  }

                                  const currentYear = moment().year();
                                  const effectiveBatchYear = plan?.batchYear
                                    ? Number(plan.batchYear)
                                    : currentYear;
                                  const isCurrentYear = effectiveBatchYear === currentYear;
                                  const monthMinDate = isCurrentYear
                                    ? moment().startOf("month").toDate()
                                    : moment({
                                        year: effectiveBatchYear,
                                        month: 0,
                                        day: 1,
                                      })
                                        .startOf("month")
                                        .toDate();

                                   const monthMaxDate = moment({
                                     year: effectiveBatchYear,
                                     month: 11,
                                     day: 1,
                                   })
                                     .endOf("month")
                                     .toDate();
                    
                                  return (
                                    <>
                                      <Grid
                                        container
                                        spacing={2}
                                        alignItems="center"
                                        mb={isProvideMarginBottom(index) ? 2 : 0}
                                      >
                                          <Grid item xs={2}>
                                            <TextInputComponent
                                              placeholder=""
                                              backgroundColor={THEME_COLORS.white}
                                              borderStyle="solid"
                                              value={plan?.planName}
                                              containerStyle={{
                                                padding: 0,
                                              }}
                                              onchange={(e) =>
                                                handlePlanChange(index, "planName", e.target.value)
                                              }
                                            />
                                          </Grid>
                                        
                    
                                        <Grid item xs={2}>
                                          <Box>
                                            <TextInputComponent
                                              type="number"
                                              placeholder=""
                                              backgroundColor={THEME_COLORS.white}
                                              borderStyle="solid"
                                              value={plan?.duration}
                                              onchange={(e) =>
                                                handlePlanChange(
                                                  index,
                                                  "duration",
                                                  e.target.value,
                                                )
                                              }
                                              containerStyle={{
                                                padding: 0,
                                              }}
                                            />
                                          </Box>
                                        </Grid>
                    
                                        <Grid item xs={2}>
                                          <Box>
                                            <DatePickerComponent
                                              containeStyle={{
                                                padding: 0,
                                              }}
                                              customInput={
                                                <input
                                                  style={{
                                                    backgroundColor: THEME_COLORS.white,
                                                    border: `1px solid ${THEME_COLORS.inputBorderColor}`,
                                                  }}
                                                />
                                              }
                                              dateFormat="dd/MM/yyyy"
                                              minDate={moment().startOf("day").toDate()}
                                              selected={
                                                plan?.planExpiryDate &&
                                                moment(
                                                  plan.planExpiryDate,
                                                  "YYYY-MM-DD",
                                                  true,
                                                ).isValid()
                                                  ? moment(
                                                      plan.planExpiryDate,
                                                      "YYYY-MM-DD",
                                                    ).toDate()
                                                  : null
                                              }
                                              onChange={(date) => {
                                                handlePlanChange(
                                                  index,
                                                  "planExpiryDate",
                                                  date
                                                    ? moment(date).format("YYYY-MM-DD")
                                                    : "",
                                                  );
                                              }}
                                            />
                                          </Box>
                                        </Grid>
                                        <Grid item xs={3}>
                                          <Box
                                            sx={{
                                              display: "flex",
                                            }}
                                          >
                                            <Box>
                                              <DatePickerComponent
                                                containeStyle={{
                                                  padding: 0,
                                                }}
                                                customInput={
                                                  <input
                                                    style={{
                                                      backgroundColor: THEME_COLORS.white,
                                                      border: `1px solid ${THEME_COLORS.inputBorderColor}`,
                                                    }}
                                                  />
                                                }
                                                dateFormat="MMMM"
                                                showMonthYearPicker
                                                minDate={monthMinDate}                                                
                                                maxDate={monthMaxDate}
                                                placeholderText="Month"
                                                selected={
                                                  plan?.batchMonth
                                                  ? moment({
                                                      year: Number(plan?.batchYear) || moment().year(),
                                                      month: Number(plan.batchMonth) - 1,
                                                      day: 1,
                                                    }).toDate()
                                                  : null
                                                }
                                                onChange={(date) => {
                                                  handlePlanChange(
                                                    index,
                                                    "batchMonth",
                                                    moment(date).month() + 1,
                                                  );
                                                }}
                                              />
                                            </Box>
                    
                                            <Box sx={{ ml: 1 }}>
                                              <DatePickerComponent
                                                containeStyle={{
                                                  padding: 0,
                                                }}
                                                customInput={
                                                  <input
                                                    style={{
                                                      backgroundColor: THEME_COLORS.white,
                                                      border: `1px solid ${THEME_COLORS.inputBorderColor}`,
                                                    }}
                                                  />
                                                }
                                                showYearPicker
                                                minDate={moment().startOf("year").toDate()}
                                                placeholderText="Year"
                                                selected={
                                                  plan?.batchYear
                                                    ? moment()
                                                        .year(Number(plan.batchYear))
                                                        .startOf("year")
                                                        .toDate()
                                                    : null
                                                }
                                                dateFormat="yyyy"
                                                onChange={(date) => {
                                                  handlePlanChange(
                                                    index,
                                                    "batchYear",
                                                    moment(date).year(),
                                                  );
                                                }}
                                              />
                                            </Box>
                                          </Box>
                                        </Grid>
                                        <Grid item xs={2}>
                                          <Box>
                                            <TextInputComponent
                                              type="number"
                                              placeholder=""
                                              backgroundColor={THEME_COLORS.white}
                                              borderStyle="solid"
                                              value={plan?.price}
                                              onchange={(e) =>
                                                handlePlanChange(
                                                  index,
                                                  "price",
                                                  e.target.value,
                                                )
                                              }
                                              containerStyle={{
                                                padding: 0,
                                              }}
                                            />
                                          </Box>
                                        </Grid>
                                        <Grid
                                          item
                                          xs={1}
                                          display={"flex"}
                                          justifyContent={"center"}
                                        >
                                          <Box
                                            sx={{
                                              display: "flex",
                                            }}
                                          >
                                            {index > 1 && (
                                              <IconButtonComponent
                                                btnType={"deleteIconbtn"}
                                                onclick={() => handleDeletePlan(index)}
                                              />
                                            )}
                    
                                            { index > 0 && (index + 1 === plans?.length) ? (
                                              <Box
                                               sx={{
                                                ml:2
                                               }}
                                               >
                                                <IconButtonComponent
                                                 btnType={"addIconbtn"}
                                                 onclick={() => handleAddPlan()}
                                               />
                                              </Box>
                                            ) : (
                                              <Box
                                                sx={{
                                                  display: "flex",
                                                  width: "50px",
                                                  borderRadius: 5,
                                                  justifyContent: "center",
                                                  alignItems: "center",
                                                  padding: 1,
                                                  ml: 1,
                                                }}
                                              ></Box>
                                            )}
                                          </Box>
                                        </Grid>
                                      </Grid>
                    
                                      <Grid mb={1} container>
                                        <Grid item xs={2}>
                                          {planErrors?.[index]?.planName && (
                                            <Typography
                                              ml={1}
                                              fontWeight={500}
                                              className="input-error-text"
                                            >
                                              {planErrors?.[index]?.planName}
                                            </Typography>
                                          )}
                                        </Grid>
                    
                                        <Grid item xs={2}>
                                          {planErrors?.[index]?.duration && (
                                            <Typography
                                              ml={1}
                                              fontWeight={500}
                                              className="input-error-text"
                                            >
                                              {planErrors?.[index]?.duration}
                                            </Typography>
                                          )}
                                        </Grid>
                                        <Grid item xs={2}>
                                          {planErrors?.[index]?.expiry && (
                                            <Typography
                                              ml={1}
                                              fontWeight={500}
                                              className="input-error-text"
                                            >
                                              {planErrors?.[index]?.expiry}
                                            </Typography>
                                          )}
                                        </Grid>
                                        <Grid item xs={3}>
                                          {planErrors?.[index]?.batch && (
                                            <Typography
                                              ml={1}
                                              fontWeight={500}
                                              className="input-error-text"
                                            >
                                              {planErrors?.[index]?.batch}
                                            </Typography>
                                          )}
                                        </Grid>
                                        <Grid item xs={2}>
                                          {planErrors?.[index]?.price && (
                                            <Typography
                                              ml={1}
                                              fontWeight={500}
                                              className="input-error-text"
                                            >
                                              {planErrors?.[index]?.price}
                                            </Typography>
                                          )}
                                        </Grid>
                                        <Grid item xs={1}></Grid>
                                      </Grid>
                                    </>
                                  );
                                })}
                              </Box>
                    
                              <Stack direction="row" spacing={1} alignItems="center">
                                <FontAwesomeIcon
                                  icon={faInfoCircle}
                                  color={THEME_COLORS.grayDark}
                                  size="sm"
                                />
                    
                                <Typography
                                  variant="caption"
                                  color="text.secondary"
                                  sx={{ fontStyle: "italic" }}
                                >
                                  At least one plan is required for paid courses.
                                </Typography>
                              </Stack>
                            </CardContent>
                          </Card>
                        </Grid>
                      )}
                    
                      <Grid container spacing={3} mt={0}>
                        <Grid item xs={12} sm={12} md={8}>
                          <Card
                            elevation={0}
                            sx={{
                              borderRadius: 3,
                              border: `1px solid ${THEME_COLORS.grayLight}`,
                              height: "100%",
                            }}
                          >
                            <CardContent sx={{ p: 4 }}>
                              <TextAreaComponent
                                textlabel={"Course Description"}
                                placeholder={"Enter course description"}
                                isError={descriptionError}
                                name={"description"}
                                value={description}
                                error="Please enter the description"
                                onchange={onDescriptionChange}
                                height={250}
                              />
                            </CardContent>
                          </Card>
                        </Grid>
                    
                        <Grid item xs={12} sm={12} md={4}>
                          <Card
                            elevation={0}
                            sx={{
                              borderRadius: 3,
                              border: `1px solid ${THEME_COLORS.grayLight}`,
                              height: "100%",
                            }}
                          >
                            <CardContent sx={{ p: 4 }}>
                              <Typography
                                color={THEME_COLORS.gray3}
                                fontWeight={600}
                                fontSize={24}
                                mb={3}
                              >
                                Course Thumbnail
                              </Typography>
                    
                              <ThumbnailUploadComponent
                                onChange={(file) => {
                                  if (file) {
                                    setNewImageError(false);
                                    setNewImageErrorMsg("");
                                    setImg(file);
                                    const objectUrl = URL.createObjectURL(file);
                                    setImgPath(objectUrl);
                                    setIsUploadedImg(true);
                                  }
                                }}
                               description="PNG, JPG, JPEG up to 2MB"
                              />
                              {newImageError ? (
                                <p className="input-error-text">{newImageErrorMsg}</p>
                              ) : null}
                    
                              {imgPath && (
                                <Box
                                  mt={3}
                                  sx={{
                                    border: `1px solid ${THEME_COLORS.grayLight}`,
                                    borderRadius: 2,
                                    p: 2,
                                  }}
                                >
                                  <Stack direction="row" spacing={2} alignItems="center">
                                    <Box
                                      component="img"
                                      src={imgPath}
                                      sx={{
                                        width: 46,
                                        height: 46,
                                        borderRadius: 1,
                                        objectFit: "cover",
                                      }}
                                    />
                                    <Box flex={1}>
                                      <Typography fontWeight={500} fontSize={14}>
                                        {img?.name ? img?.name : ""}
                                      </Typography>
                    
                                      <Typography
                                        variant="caption"
                                        color="text.secondary"
                                      >
                                        { img?.size ? formatFileSize(img?.size) : ""}
                                      </Typography>
                                    </Box>
                                    <Box
                                      onClick={() => {
                                        setImg(null);
                                        setImgPath(null);
                                        setIsUploadedImg(false);
                                      }}
                                      sx={{
                                        display: "inline-flex",
                                        cursor: "pointer",
                                        "& svg": {
                                          color: THEME_COLORS.gray2,
                                          transition: "color 0.2s ease",
                                        },
                                        "&:hover svg": {
                                          color: THEME_COLORS.danger,
                                        },
                                      }}
                                    >
                                      <FontAwesomeIcon icon={faXmark} size="xl" />
                                    </Box>
                                  </Stack>
                                </Box>
                              )}
                            </CardContent>
                          </Card>
                        </Grid>
                      </Grid>
                    </Grid>             

                    <Grid item xs={12} mt={3}>
                      <Card elevation={0} sx={{ borderRadius: 3, border: `1px solid ${THEME_COLORS.grayLight}` }}>
                        <CardContent sx={{ p: 4 }}>
                          <Typography color={THEME_COLORS.gray3} fontWeight={600} fontSize={24} mb={3}>
                            Walkthrough Video
                          </Typography>
                          <Grid container spacing={3} alignItems="center">
                            <Grid item xs={12} md={8}>
                              <ThumbnailUploadComponent
                                accept={[".mp4", ".mov", ".ogg", ".qt"]}
                                label="Click to upload or drag and drop a video"
                                description="MP4, MOV"
                                onChange={setWalkthroughVideo}
                              />
                              {walkthroughVideo && (
                                <Stack direction="row" spacing={2} alignItems="center" mt={2}>
                                  <Typography variant="body2" color="text.secondary" sx={{ flex: 1 }}>
                                    {walkthroughVideo.name}
                                  </Typography>
                                  <IconButtonComponent
                                    btnType="deleteIconbtn"
                                    onclick={() => setWalkthroughVideo(null)}
                                  />
                                </Stack>
                              )}
                            </Grid>
                            <Grid item xs={12} md={4}>
                              <Box className="add-course-free-box">
                                <Box>
                                  <Typography color={THEME_COLORS.gray3} fontWeight={600} fontSize={18}>
                                    Mandatory to watch
                                  </Typography>
                                  <Typography variant="body2" color="text.secondary">
                                    Require students to watch this video before continuing
                                  </Typography>
                                </Box>
                                <SwitchButtonComponet
                                  checked={isWalkthroughMandatory}
                                  onChange={(event) => setIsWalkthroughMandatory(event.target.checked)}
                                  inputProps={{ "aria-label": "Mandatory to watch" }}
                                />
                              </Box>
                            </Grid>
                          </Grid>
                        </CardContent>
                      </Card>
                    </Grid>       
            <Grid
            mt={4}
            rowGap={4}
            container
            direction={"row"}
            justifyContent={"center"}
          >
            <Grid item xs={12} sm={2} mr={2}>
              <TextButtonComponet
                text="Cancel & Exit"
                classStyle="btn btn-secondary"
                onButtonClick={() => {
                  navigate(-1);
                }}
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              <TextButtonComponet
                text={"Save Course"}
                onButtonClick={onAddCourse}
                isDisabled={isSubmitting}
                loading={isSubmitting}
              />
            </Grid>

            <Grid item xs={12} />
          </Grid>
                    
                </Box>
            </div>
        </>
    );
};

export default connect(
    (state) => ({
        verifyEmailData: state.auth.get("verifyEmailData"),
    }),
    {
        validateEmail: Actions.auth.validateEmail,
        createCourse: Actions.course.createCourse,
    }
)(AdminCoursAddScreen);
